import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { i18n } from '@/i18n';
import SvgLoader from '@/utils/SvgLoader.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderStatusVisibleButton',
  props: {
    orderStatusStr: { default: '' },
    isShowOrderStatus: { type: Boolean, default: true }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

/**
 * 発注ステータスバッジ
 */
const props = __props;

const emits = __emit;

const t = i18n.t;

const iconName = computed(() => {
  if (props.isShowOrderStatus) {
    switch (props.orderStatusStr) {
      case 'QuantityConfirmed':
        return 'iconEyeEnabledBlue';
      case 'DeliveryDateConfirmed':
        return 'iconEyeEnabledBlue';
      default:
        return 'iconEyeEnabled';
    }
  }
  switch (props.orderStatusStr) {
    case 'QuantityConfirmed':
      return 'iconEyeDisableBlue';
    case 'DeliveryDateConfirmed':
      return 'iconEyeDisableBlue';
    default:
      return 'iconEyeDisable';
  }
});

/**
 * クリック時の処理
 */
const onClick = () => {
  // 現在の表示状態の逆の値を親に通知する
  emits('click', !props.isShowOrderStatus);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(`status-tag__container status-tag__container--${_ctx.orderStatusStr}`),
    style: _normalizeStyle({ opacity: props.isShowOrderStatus ? 1 : 0.4 }),
    onClick: onClick
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(`status-tag__content status-tag__content--${_ctx.orderStatusStr}`)
    }, _toDisplayString(_unref(t)(_ctx.orderStatusStr)), 3),
    _createVNode(SvgLoader, {
      class: "status-tag__icon",
      name: iconName.value
    }, null, 8, ["name"])
  ], 6))
}
}

})